<agpr-take-over-panel
    [id]="id"
    [header]="'Discover.distribution.personalizationWorkbench.header' | localize : {
        'personalization': personalizationTypeLabelMap.get(personalizationType) }"
    [responsiveWidth]="true"
    [minPanelWidth]="950"
    [maxPanelWidth]="1900"
    [showFooter]="false"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="close()"
>
    <div class="container">
        <div class="container-left">
            <div class="main">
                @if (aiEnabled) {
                    <div class="main-left">
                        <agpr-scroll-panel class="main-scrollLeft">
                            <div class="copilot-container">
                                <span
                                    class="fa-kit-duotone fa-agpr-ai copilot-icon"
                                    aria-hidden="true"
                                ></span>
                                @if (personalizationType === personalizationEnum.INTRO) {
                                    <span>{{ 'Discover.distribution.personalizationWorkbench.prCoPilotIntro' | localize }}</span>
                                } @else {
                                    <span>{{ 'Discover.distribution.personalizationWorkbench.prCoPilotOutro' | localize }}</span>
                                }
                            </div>
                            <agpr-panel
                                class="mainPanel"
                                header="Discover.distribution.personalizationWorkbench.desiredOutcome"
                                tooltip="Discover.distribution.personalizationWorkbench.desiredOutcome.tooltip"
                                [toggleable]="false"
                                [marginTop]="0"
                            >
                                <agpr-dropdown
                                    [id]="id + '_desiredOutcome_dropdown'"
                                    [(ngModel)]="desiredOutcome"
                                    (ngModelChange)="desiredOutcomeChanged($event)"
                                    [options]="desiredOutcomeOptions"
                                ></agpr-dropdown>
                                @if (desiredOutcome.value === desiredOutputType.CUSTOM) {
                                    <agpr-textarea-input
                                        [id]="id + '_customDesiredOutcome'"
                                        [bottomMargin]="false"
                                        [maxLength]="128"
                                        placeholder="Discover.distribution.personalizationWorkbench.desiredOutcomeText.placeholder"
                                        [(ngModel)]="customDesiredOutcome"
                                    ></agpr-textarea-input>
                                } @else {
                                    <agpr-dropdown
                                        [id]="id + '_desiredSubOutcome_dropdown'"
                                        [disabled]="desiredOutcome.value === desiredOutputType.NONE"
                                        [(ngModel)]="desiredOutcomeSub"
                                        [options]="desiredOutcomeSubOptions"
                                        placeholder="Discover.distribution.personalizationWorkbench.selectOption"
                                    ></agpr-dropdown>
                                }
                            </agpr-panel>
                            <agpr-panel
                                class="mainPanel"
                                header="Discover.distribution.personalizationWorkbench.settings"
                                [toggleable]="false"
                            >
                                <agpr-dropdown
                                    [id]="id + '_tone_dropdown'"
                                    label="Discover.distribution.personalizationWorkbench.tone"
                                    [(ngModel)]="tone"
                                    [options]="toneOptions"
                                ></agpr-dropdown>
                                <agpr-dropdown
                                    [id]="id + '_length_dropdown'"
                                    label="Discover.distribution.personalizationWorkbench.length"
                                    [(ngModel)]="length"
                                    [options]="lengthOptions"
                                ></agpr-dropdown>
                                <agpr-dropdown
                                    [id]="id + '_urgency_dropdown'"
                                    label="Discover.distribution.personalizationWorkbench.urgency"
                                    [(ngModel)]="urgency"
                                    [options]="urgencyOptions"
                                ></agpr-dropdown>
                                <div class="language">
                                    <span> {{ 'Discover.distribution.personalizationWorkbench.language' | localize }} </span>
                                    <div class="language-container">
                                        <agpr-dropdown
                                            [id]="id + '_language_dropdown'"
                                            label="Discover.distribution.personalizationWorkbench.generateIn"
                                            [(ngModel)]="language"
                                            [options]="languageOptions"
                                        ></agpr-dropdown>
                                        <div class="language-containerRow">
                                            <agpr-checkbox
                                                [id]="id + '_useRecipientLang_checkbox'"
                                                label="Discover.distribution.personalizationWorkbench.preferredLang"
                                                [(ngModel)]="useRecipientLanguage"
                                                [binary]="true"
                                            ></agpr-checkbox>
                                            <i
                                                class="fa-regular fa-circle-info"
                                                agprTooltip="Discover.distribution.personalizationWorkbench.language.tooltip"
                                            ></i>
                                        </div>
                                    </div>
                                </div>
                            </agpr-panel>

                            <agpr-panel
                                class="mainPanel"
                                header="Discover.distribution.personalizationWorkbench.personalNotes"
                                tooltip="Discover.distribution.personalizationWorkbench.personalNote.tooltip"
                                [toggleable]="false"
                            >
                                <agpr-textarea-input
                                    [id]="id + '_personalNotes_input'"
                                    [rows]="3"
                                    [bottomMargin]="false"
                                    [maxLength]="256"
                                    [(ngModel)]="personalNotes"
                                    placeholder="Discover.distribution.personalizationWorkbench.personalNote.placeholder"
                                ></agpr-textarea-input>
                            </agpr-panel>
                        </agpr-scroll-panel>
                        <div class="main-leftBottom">
                            <agpr-button
                                [id]="id + '_generateButton'"
                                [label]="hasGenerated ? 'Common.dialog.aiHelper.regenerateButton' : 'Common.dialog.aiHelper.generateButton'"
                                [style]="buttonTypes.tertiary"
                                [disabled]="loading"
                                (click)="generate()"
                            ></agpr-button>
                        </div>
                    </div>
                }
                <div
                    class="main-right"
                    [ngClass]="{'main-rightOnly': !aiEnabled}"
                >
                    <agpr-scroll-panel
                        #rightScrollPanel
                        class="main-scrollRight"
                    >
                        <agpr-panel
                            id="generated_content"
                            class="mainPanel"
                            [header]="personalizationType === personalizationEnum.INTRO ?
                                'Discover.distribution.personalizationWorkbench.intro': 'Discover.distribution.personalizationWorkbench.outro'"
                            [toggleable]="false"
                            [agprLoading]="loading"
                        >
                            <agpr-rich-text-editor-ck
                                class="richTextEditor"
                                [ngClass]="{'richTextEditor-error': isTextExceedingLimit}"
                                [(ngModel)]="generatedContent"
                                (ngModelChange)="checkErrors()"
                                [richTextEditorConfig]="ckEditorConfig"
                            ></agpr-rich-text-editor-ck>
                            @if (isTextExceedingLimit) {
                                <agpr-form-message>
                                    {{ 'Discover.distribution.personalizationWorkbench.maxLengthError' | localize }}
                                </agpr-form-message>
                            }
                        </agpr-panel>

                        @if (!storedHideDisclaimer && hasGenerated) {
                            <div class="disclaimer">
                                <agpr-ai-disclaimer
                                    class="disclaimer-prompt"
                                    [marginTop]="0"
                                    [confirmButton]="false"
                                    (disclaimerValue)="toggleDisclaimer($event)"
                                ></agpr-ai-disclaimer>
                                <div class="disclaimer-toggle">
                                    <agpr-checkbox
                                        [id]="id + '_disclaimer_checkbox'"
                                        label="Discover.distribution.personalizationWorkbench.disclaimerToggle"
                                        [(ngModel)]="hideDisclaimer"
                                        (ngModelChange)="setDisclaimerState()"
                                        [disabled]="!disclaimerState"
                                        [binary]="true"
                                    ></agpr-checkbox>
                                </div>
                            </div>
                        }
                    </agpr-scroll-panel>
                </div>
            </div>

            <div class="main-footer">
                <agpr-button
                    [id]="id + '_close_Button'"
                    (click)="close()"
                    [style]="buttonTypes.secondary"
                    label="cancel"
                ></agpr-button>
                <agpr-button
                    [id]="id + '_confirm_Button'"
                    (click)="use()"
                    [style]="buttonTypes.primary"
                    [disabled]="isTextExceedingLimit ? true : (
                        hasGenerated ? (storedHideDisclaimer ? streamingStarted : !disclaimerState)
                        : generatedContentOriginal.localeCompare(generatedContent) === 0)"
                    label="Discover.distribution.personalizationWorkbench.use"
                ></agpr-button>
            </div>
        </div>
        <div class="container-right">
            <agpr-rhp-contexts
                [id]="id + '_rhpContexts'"
                [overlayContainer]="overlayContainer"
                [hiddenNoContentMessage]="true"
                [disableContentToggle]="true"
            ></agpr-rhp-contexts>
        </div>
    </div>
</agpr-take-over-panel>